var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8Slovakia(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "48px",
    height: "48px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M24,4C15.421,4,8.125,9.412,5.284,17h37.431C39.875,9.412,32.579,4,24,4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1976d2",
    d: "M44,24c0-2.467-0.468-4.818-1.284-7H5.284C4.468,19.182,4,21.533,4,24s0.468,4.818,1.284,7h37.431 C43.532,28.818,44,26.467,44,24z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M42.716,31H5.284C8.125,38.588,15.421,44,24,44S39.875,38.588,42.716,31z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ff3d00",
    d: "M15.085,31.108c-2.424-1.131-6.029-2.365-6.084-6.927c-0.055-4.562-0.084-6.999-0.084-6.999 l11.999-0.145c0,0,0.03,2.484,0.084,6.999C21.055,28.598,17.481,29.919,15.085,31.108"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#eceff1",
    d: "M7.905,16.194c0,0,0.037,3.027,0.097,7.999c0.06,4.976,4.249,6.684,7.096,7.915 C17.914,30.808,22.06,29,22,24.024c-0.06-4.972-0.097-7.999-0.097-7.999L7.905,16.194z M21,24.036 c0.055,4.562-3.519,5.883-5.915,7.072c-2.424-1.131-6.029-2.365-6.084-6.927c-0.055-4.562-0.084-6.999-0.084-6.999l11.999-0.145 C20.916,17.037,20.946,19.521,21,24.036z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.573,23.59c0.731,0.003,2.153,0.013,3.417-0.424c0,0-0.026,0.453-0.019,0.981 s0.043,0.98,0.043,0.98c-1.169-0.373-2.606-0.363-3.426-0.345l0.034,2.82l-1.152,0.014l-0.034-2.816 c-0.824-0.002-2.262,0.023-3.421,0.428c0,0,0.026-0.453,0.019-0.985c-0.006-0.527-0.043-0.98-0.043-0.98 c1.275,0.41,2.7,0.366,3.43,0.341l-0.021-1.769c-0.668,0.004-1.341-0.081-2.422,0.295c0,0-0.005-0.453-0.012-0.98 c-0.006-0.531-0.012-0.984-0.012-0.984c1.086,0.35,1.764,0.498,2.428,0.486c-0.049-1.124-0.394-2.531-0.394-2.531 s0.676,0.043,0.942,0.039c0.266-0.003,0.941-0.062,0.941-0.062s-0.311,1.414-0.333,2.535c0.668-0.004,1.338-0.153,2.416-0.525 c0,0-0.026,0.453-0.019,0.981c0.006,0.531,0.043,0.984,0.043,0.984c-1.086-0.35-1.761-0.264-2.425-0.252L15.573,23.59z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#1976d2",
    d: "M16.873,27.735c0,0-0.657-1.641-1.848-1.626c-1.187,0.014-1.808,1.67-1.808,1.67 s-0.361-0.777-1.334-0.765c-0.598,0.007-1.219,0.632-1.522,1.128c1.284,1.547,3.294,2.3,4.724,2.967 c1.414-0.701,3.346-1.431,4.593-3.009c-0.315-0.488-0.893-1.169-1.491-1.162C17.219,26.949,16.873,27.735,16.873,27.735z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8Slovakia);
export default __webpack_public_path__ + "static/media/icons8-slovakia.991fecd449dd2c09850b16917172fbff.svg";
export { ForwardRef as ReactComponent };